// ============================================================
// ANSICHTSSACHE-AGENT – Die ganze Zeile oeffnet
// ============================================================
// Hausregel (Ansage vom 24.09.2026): in JEDER Liste ist die
// ganze Zeile anklickbar und oeffnet, was sie zeigt — nicht nur
// die Nummer oder der Name. Ausgenommen ist nur, was in der Zeile
// selbst etwas tut (Kaestchen, Knopf, Verweis auf etwas anderes).
//
// WIE: kein Klickhorcher an der Zeile. Der machte aus der Liste
// eine Client-Komponente und aus der Zeile ein Ziel ohne
// Tastaturweg und ohne „in neuem Tab oeffnen". Stattdessen traegt
// EIN echter Verweis in der Zeile — meist auf der Nummer — eine
// unsichtbare Flaeche (`after:inset-0`), die sich ueber die ganze
// Zeile legt. Fokussierbar, kopierbar, mittlere Maustaste geht.
//
// DREI TEILE, die zusammengehoeren:
//
//   Zeilenverweis   der Verweis mit der Flaeche, fuer Links
//   ZEILENFLAECHE   nur die Flaeche, fuer einen Knopf, der ein
//                   Blatt oeffnet statt eine Seite
//   UEBER_DER_ZEILE fuer alles, was in der Zeile EIGENSTAENDIG
//                   anklickbar bleiben soll — es liegt auf `z-[1]`
//                   ueber der Flaeche und unter Spaltenkopf und
//                   Summenzeile (beide `z-10`). Siehe
//                   `reference_listenzeile_flaeche_und_stapel`.
//
// Die Zeile muss `relative` sein, sonst misst die Flaeche am
// naechsten positionierten Vorfahren — in einer Tabelle ist das
// der ganze Kasten, und die erste Zeile deckt alle anderen zu.
// `TableRow` ist darum von sich aus `relative`; eine Liste ohne
// Tabelle (Projekte, Links) setzt es an ihrer Zeile selbst.
//
// PREIS: Text in einer solchen Zeile laesst sich nicht mehr mit
// der Maus markieren — die Flaeche liegt darueber. Der volle Text
// steht auf dem Blatt, das die Zeile oeffnet.
// ============================================================

import Link from "next/link";
import { cn } from "@/lib/utils";

/** Die unsichtbare Flaeche ueber der ganzen Zeile. */
export const ZEILENFLAECHE = "after:absolute after:inset-0 after:content-['']";

/** Eigenstaendig anklickbar in einer Zeile mit Flaeche. */
export const UEBER_DER_ZEILE = "relative z-[1]";

export function Zeilenverweis({ className, ...props }: React.ComponentProps<typeof Link>) {
  return (
    <Link
      className={cn("hover:text-accent font-medium transition-colors", ZEILENFLAECHE, className)}
      {...props}
    />
  );
}
